import React from "react";
import { ArrowDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Reveal, Kicker } from "./motion";
import productsHero from "../assets/page-heroes/products.webp";
import newsHero from "../assets/page-heroes/news.webp";
import aboutHero from "../assets/page-heroes/about.webp";
import reportingHero from "../assets/page-heroes/reporting.webp";

const heroImages = {
  products: productsHero,
  news: newsHero,
  about: aboutHero,
  reporting: reportingHero,
};

export function PageIntro({ contentKey }) {
  const { c } = useApp();
  const navigate = useNavigate();
  const content = c[contentKey];
  const image = heroImages[contentKey];

  return (
    <section className="relative overflow-hidden bg-[#001a40] px-5 py-20 text-[#f5f7fa] md:px-8 md:py-28">
      {image && (
        <>
          <img
            src={image}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center opacity-90"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,rgba(0,26,64,0.98)_0%,rgba(0,26,64,0.9)_30%,rgba(0,26,64,0.42)_55%,rgba(0,26,64,0.08)_82%)]"
          />
        </>
      )}
      <div className="relative z-10 mx-auto max-w-[1240px]">
        <Reveal className="max-w-3xl">
          <Kicker>{content.kicker}</Kicker>
          <h1 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-6xl">{content.title}</h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#f5f7fa]/70 md:text-lg">{content.subtitle}</p>
          {contentKey === "products" && (
            <button
              type="button"
              onClick={() => navigate("/products#calculator")}
              className="mt-7 inline-flex items-center gap-2 rounded-full border border-[#e8a93d]/60 px-5 py-2.5 text-sm font-semibold text-[#e8a93d] transition-colors hover:bg-[#e8a93d] hover:text-[#002355]"
            >
              {c.cta.calculator}
              <ArrowDown size={16} />
            </button>
          )}
        </Reveal>
      </div>
    </section>
  );
}
